import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from '../shared/services/auth';
import { ConfirmationComponent } from '../confirmation/confirmation';
import { SharedData } from '../shared/sharedData';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Configuration, HttpClientCustom } from '../shared';
import { TranslateService } from '@ngx-translate/core';
import { userInfo } from 'os';
import { environment } from '../environment'

@Component({
  selector: 'header',
  templateUrl: 'header.html'
})
export class Header {
  public localState: any;
  public isNavbarCollapsed: boolean = false;
  public openSubMenu: boolean = false;
  public displayName: any;
  public _appUrl: any;
  public _biUrl: any;
  allLanguage: any = [];
  selectedlanguage: any;
  _baseUrl: string;
  checkLanguage: any;
  _userInfo: any;
  updateProfilePic: any;
  _userInfoSub: any;
  tenantImage: any;
  userInfo: any;
  // userInfo = {localeName:null};

  constructor(
    public route: ActivatedRoute,
    public _auth: Auth,
    public translate: TranslateService,
    public _global: Configuration,
    public share: SharedData,
    public http: HttpClientCustom,
    public modalService: NgbModal,
    public router: Router) {
    let result = JSON.parse(window.localStorage.getItem('userInfo'));
    this._appUrl = _global.get('USER_APP_URL');
    this._biUrl = _global.get('BI_BASE_URL');
    this.displayName = result.displayName;
    this._baseUrl = this._global.get('EPMS_BASE_URL');
    this.getLang();
    // this.getupdatedtenantImage();
    this._auth.updateProfilePic.subscribe((userInfo) => this.saveUserChanges(userInfo));
    this.getEmp();

  }

  public saveUserChanges(userInfo) {
    this.userInfo = userInfo;
    this.tenantImage = userInfo.tenantImageUrl;
    console.log(userInfo)
  }

  public openSubNavbar() {
    this.openSubMenu = !this.openSubMenu;
  }

  public closeSubNavbar() {
    this.openSubMenu = false;
    this.isNavbarCollapsed = false;
  }
  public hubClicked() {
    window.location.href = this._appUrl+"/";
  }

  public logout(): any {
    let confirmData: any = {
      type: 'logOut',
      program: null
    };
    this.share.saveData(confirmData);
    const modalRef = this.modalService.open(ConfirmationComponent,
      { windowClass: 'min-modal' }).result.then((result) => {
        if (result === 'confirmed') {
          this._auth.logout();
        }
      }, (reason) => {
        console.log(reason)
      });
  }

  public dashboardClicked() {
    window.location.href = this._appUrl + '/#/dashboard';
  }

  public getLang() {
    this.getAllLanguage().subscribe((result) => {
      this.allLanguage = result;
    });
  }

  public getAllLanguage() {
    let self = this;
    const url = self._baseUrl + 'v1/hub/settings/getAllLang';
    return self.http.get(url);
  }

  public selectLanguage(language) {
    this.selectedlanguage = language.locale;
    this.saveLanguageSelected();
  }

  public saveLanguageSelected() {
    this.changeToSelectedLanguage(this.selectedlanguage).subscribe((res) => {
      this.getEmp();
    });
  }

  public changeToSelectedLanguage(selectedLanguage) {
    let self = this;
    const url = self._baseUrl + 'v1/hub/changeLocale?locale=' + selectedLanguage;
    return this.http.post(url, selectedLanguage);
  }

  public getEmp() {
    this.getEmployeeDetail().subscribe((res) => {
      console.log(res);
      this.tenantImage = res.tenantImageUrl;
      if(environment.client=='KEA'){
          if (res.tenantName) {
            document.title = res.tenantName;
          }
      }
      this.upDateLang(res.localeName);
    });
  }

  public getEmployeeDetail() {
    console.log('HEADER');
    return this.http.get(this._baseUrl + 'v1/hub/employeeInfo');
  }

  public upDateLang(lang) {
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    userInfo.localeName = lang;
    this.checkLanguage = userInfo.localeName;
    this.upDateUserFromSettingPage(userInfo);
    this.translate.use(lang);
    document.documentElement.setAttribute('lang', lang);
  }

  public upDateUserFromSettingPage(userInfo) {
    this._userInfo = userInfo;
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }


}



// WEBPACK FOOTER //
// ./src/app/header/header.ts